<ng-container *ngIf="visible">
  <div
    appModalScrollLock
    class="fixed inset-0 z-[99998] bg-black/30 backdrop-blur-[2px]"
    (click)="close()"
    aria-hidden="true"
  ></div>

  <div
    role="dialog"
    aria-modal="true"
    aria-label="Calculadora"
    class="fixed left-1/2 top-1/2 z-[99999] -translate-x-1/2 -translate-y-1/2 w-72 select-none rounded-2xl bg-zinc-900 shadow-2xl ring-1 ring-white/10 overflow-hidden"
  >
    <div class="flex items-center justify-between px-4 pt-3 pb-1">
      <span class="text-xs font-medium text-zinc-500 tracking-widest uppercase"
        >Calculadora</span
      >
      <button
        type="button"
        (click)="close()"
        class="flex h-6 w-6 items-center justify-center rounded-full bg-zinc-700 text-zinc-400 hover:bg-zinc-600 hover:text-white transition-all active:scale-90"
        aria-label="Cerrar calculadora"
      >
        <svg
          class="h-3 w-3"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>

    <div class="px-4 pb-3 pt-1 text-right">
      <p class="min-h-[1.5rem] text-sm text-zinc-500 font-mono truncate">
        {{ expressionHistory }}&nbsp;
      </p>
      <p
        class="text-4xl font-light tracking-tight text-white font-mono truncate"
        [class.text-2xl]="formattedDisplay.length > 10"
        [class.text-red-400]="currentInput === 'Error'"
      >
        {{ formattedDisplay }}
      </p>
    </div>

    <div class="grid grid-cols-4 gap-px bg-zinc-700 border-t border-zinc-700">
      <button
        type="button"
        (click)="clear()"
        class="calc-btn bg-zinc-500 text-white hover:bg-zinc-400 active:bg-zinc-300"
      >
        C
      </button>
      <button
        type="button"
        (click)="toggleSign()"
        class="calc-btn bg-zinc-500 text-white hover:bg-zinc-400 active:bg-zinc-300"
      >
        +/−
      </button>
      <button
        type="button"
        (click)="percent()"
        class="calc-btn bg-zinc-500 text-white hover:bg-zinc-400 active:bg-zinc-300"
      >
        %
      </button>
      <button
        type="button"
        (click)="setOperator('÷')"
        [class.ring-2]="operator === '÷'"
        class="calc-btn bg-amber-500 text-white hover:bg-amber-400 active:bg-amber-300 ring-amber-300"
      >
        ÷
      </button>

      <button
        type="button"
        (click)="appendDigit('7')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        7
      </button>
      <button
        type="button"
        (click)="appendDigit('8')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        8
      </button>
      <button
        type="button"
        (click)="appendDigit('9')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        9
      </button>
      <button
        type="button"
        (click)="setOperator('×')"
        [class.ring-2]="operator === '×'"
        class="calc-btn bg-amber-500 text-white hover:bg-amber-400 active:bg-amber-300 ring-amber-300"
      >
        ×
      </button>

      <button
        type="button"
        (click)="appendDigit('4')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        4
      </button>
      <button
        type="button"
        (click)="appendDigit('5')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        5
      </button>
      <button
        type="button"
        (click)="appendDigit('6')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        6
      </button>
      <button
        type="button"
        (click)="setOperator('−')"
        [class.ring-2]="operator === '−'"
        class="calc-btn bg-amber-500 text-white hover:bg-amber-400 active:bg-amber-300 ring-amber-300"
      >
        −
      </button>

      <button
        type="button"
        (click)="appendDigit('1')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        1
      </button>
      <button
        type="button"
        (click)="appendDigit('2')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        2
      </button>
      <button
        type="button"
        (click)="appendDigit('3')"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        3
      </button>
      <button
        type="button"
        (click)="setOperator('+')"
        [class.ring-2]="operator === '+'"
        class="calc-btn bg-amber-500 text-white hover:bg-amber-400 active:bg-amber-300 ring-amber-300"
      >
        +
      </button>

      <button
        type="button"
        (click)="appendDigit('0')"
        class="calc-btn col-span-2 bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600 justify-start pl-6"
      >
        0
      </button>
      <button
        type="button"
        (click)="appendDot()"
        class="calc-btn bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600"
      >
        ,
      </button>
      <button
        type="button"
        (click)="calculate()"
        class="calc-btn bg-amber-500 text-white hover:bg-amber-400 active:bg-amber-300"
      >
        =
      </button>
    </div>

    <div class="bg-zinc-900 px-4 py-2.5">
      <button
        type="button"
        (click)="backspace()"
        class="flex w-full items-center justify-center gap-1.5 rounded-lg bg-zinc-800 py-2 text-sm text-zinc-300 hover:bg-zinc-700 active:bg-zinc-600 active:scale-[0.98] transition-all select-none"
      >
        <svg
          class="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z" />
          <line x1="18" y1="9" x2="12" y2="15" />
          <line x1="12" y1="9" x2="18" y2="15" />
        </svg>
        Borrar
      </button>
    </div>
  </div>
</ng-container>
